import PropTypes from 'prop-types';

export const consentFormatPropType = PropTypes.oneOf(['EXPLICIT', 'IMPLICIT']);

export const cardholderConsentFormatPropType = PropTypes.oneOf(['EXPLICIT', 'IMPLICIT', 'HOSTED']);
